






























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IDocument, IUser, IFileWrapper, Maybe } from '@/models';
import { BaseDetail } from '../Base/BaseDetail';
import { Prop } from 'vue-property-decorator';

const namespace = 'document';
const ns = { namespace };

@Component
export default class DocumentDetail extends BaseDetail<IDocument> {
  @Prop({ default: false }) modal: boolean;
  modalPath: Maybe<object> = null;
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IDocument>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  mounted() {
    this.setValue(this.entityPatch, 'creator_id', this.user.id);
    this.loadEntity()?.then(() => {
      this.setValue(this.entityPatch, 'files', this.baseEntity.files);
    });
  }
  onFilesChange(val: IFileWrapper[]) {
    const arr = this.entityPatch.files ? this.entityPatch.files : [];
    this.setValue(
      this.entityPatch,
      'files',
      [...arr, ...val].filter(
        (value, index, self) => self.indexOf(value) === index,
      ),
    );
  }
  previewFile(file: IFileWrapper) {
    if (file.apiRepresentation) {
      this.modalPath = file.apiRepresentation;
    }
  }
}
